import { createApp } from 'vue';
import App from './app';
import { store } from './store';
import { configMain } from './main-config';
import router from './router';
import 'element-plus/theme-chalk/el-loading.css';

// 提供给 api 模块使用
export { usePTeamStore } from '@/store/modules/team';
export { router };

const app = createApp(App);

app.use(store);

configMain({ app });

app.use(router); // .use(dialogDrag);

app.mount('#app');
